import { Routes } from '@angular/router';
import { loginGuard } from './guards/auth-login.guard';
import { authGuard } from './guards/auth.guard'; 
export const routes: Routes = [
  { 
    path: '', 
    pathMatch: 'full', 
    redirectTo: 'login' 
  },
  {
    path: 'login',
    canMatch: [loginGuard],
    title: 'Iniciar Sesión - VELO',
    loadComponent: () =>
      import('./auth/feature/login/login.component').then((c) => c.LoginComponent),
  },
  {
    path: 'admin',
    loadComponent: () =>
      import('./theme/layouts/admin-layout/admin-layout.component').then(
        (c) => c.AdminLayoutComponent
      ),
    canMatch: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard/home',
        pathMatch: 'full',
      },
      {
        path: 'dashboard/home',
        title: 'Inicio - VELO',
        loadComponent: () =>
          import('./dashboard/feature/home/home.component').then(
            (c) => c.HomeComponent
          ),
      },
      {
        path: 'clients/list',
        title: 'Clientes - VELO',
        loadComponent: () =>
          import('./clients/feature/client-list/client-list.component').then(
            (c) => c.ClientListComponent
          ),
      },
      {
        path: 'businesses/list',
        title: 'Negocios - VELO',
        loadComponent: () =>
          import('./businesses/feature/business-list/business-list.component').then(
            (c) => c.BusinessListComponent
          ),
      },
      {
        path: 'businesses/new',
        title: 'Crear negocio - VELO',
        loadComponent: () =>
          import('./businesses/feature/business-form/business-form.component').then(
            (c) => c.BusinessFormComponent
          ),
      },
      {
        path: 'businesses/:id/edit',
        title: 'Editar negocio - VELO',
        loadComponent: () =>
          import('./businesses/feature/business-form/business-form.component').then(
            (c) => c.BusinessFormComponent
          ),
      },
      {
        // Old path of the module, kept so saved links keep working.
        path: 'merchants/list',
        redirectTo: 'businesses/list',
        pathMatch: 'full',
      },
      {
        path: 'promotions/list',
        title: 'Promociones - VELO',
        loadComponent: () =>
          import('./promotions/feature/promotion-list/promotion-list.component').then(
            (c) => c.PromotionListComponent
          ),
      },
      {
        path: 'helplines/list',
        title: 'Líneas de Atención - VELO',
        loadComponent: () =>
          import('./helplines/feature/helpline-list/helpline-list.component').then(
            (c) => c.HelplineListComponent
          ),
      },
      {
        path: 'categories/list',
        title: 'Categorías - VELO',
        loadComponent: () =>
          import('./categories/feature/category-list/category-list.component').then(
            (c) => c.CategoryListComponent
          ),
      },
      {
        path: 'admins/list',
        title: 'Administradores - VELO',
        loadComponent: () =>
          import('./admins/feature/admin-list/admin-list.component').then(
            (c) => c.AdminListComponent
          ),
      },
    ],
  },
  { 
    path: '**', 
    redirectTo: 'login' 
  },
];